import { render, staticRenderFns } from "./UsefulResources.vue?vue&type=template&id=4511d7de&scoped=true&"
import script from "./UsefulResources.vue?vue&type=script&lang=js&"
export * from "./UsefulResources.vue?vue&type=script&lang=js&"
import style0 from "./UsefulResources.vue?vue&type=style&index=0&id=4511d7de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4511d7de",
  null
  
)

export default component.exports